import { GetterTree, Store } from "vuex";
import { IRootState, IRootGetters } from "./types";
import { buildGetter } from "@dcc/store/utils";
import { determineNextRoute } from "@dcc/router/nextroute";
import { DrinkFrequency } from "@dcc/types/drinkFrequency";

const getterNames = {
  GETNEXTROUTE: "getNextRoute",
  GETCURRENTROUTE: "getCurrentRoute"
};

export const getters: GetterTree<IRootState, IRootState> = {
  [getterNames.GETNEXTROUTE](
    state: IRootState,
    getters: IRootState,
    rootState: IRootState,
    rootGetters: IRootGetters
  ): string | undefined {
    return determineNextRoute(state.currentRoute, {
      drinkingFrequency:
        rootGetters["drinking/drinkFrequency"] || DrinkFrequency.Never
    });
  },
  [getterNames.GETCURRENTROUTE](state: IRootState): string | undefined {
    return state.currentRoute;
  }
};

export const findGetters = (store: Store<IRootState>) => {
  return {
    getNextRoute: () =>
      buildGetter<string | undefined>(store, "", getterNames.GETNEXTROUTE),
    getCurrentRoute: () =>
      buildGetter<string | undefined>(store, "", getterNames.GETCURRENTROUTE)
  };
};
